import { Glue42Core } from "@glue42/core";

import {Glue42Office} from "../../../glue4office";
import {generateConversationId} from "../helpers/index";
import {SyncTrackCalendarItemMethodName, SyncUntrackCalendarItemMethodName} from "../helpers/methodNames";
import {validateCalendarEventParameters, validateId} from "../helpers/validations";
import trackItemDictionary from "../dictionaries/TrackItemDictionary";

const combineConversationIds = (event: Glue42Office.Outlook.T42Appointment | Glue42Office.Outlook.T42Meeting, conversationId: Glue42Office.Outlook.T42Id, isTrackEmail: boolean) => {
    const conversationIds = trackItemDictionary.containsIds(event.ids) ? trackItemDictionary.get(event.ids) : [];

    if (isTrackEmail) {
        const newConversationIds = conversationId ? conversationId : generateConversationId();
        conversationIds.push(newConversationIds);

        if (!trackItemDictionary.containsIds(event.ids)) {
            trackItemDictionary.add(event.ids, conversationIds);
        }
    }
    return conversationIds;
};

export const handleTrackingItems = (agm: Glue42Core.AGM.API,
                                    action: string,
                                    event: Glue42Office.Outlook.T42Appointment | Glue42Office.Outlook.T42Meeting,
                                    conversationId?: Glue42Office.Outlook.T42Id): Promise<{
                                        event: Glue42Office.Outlook.T42Appointment | Glue42Office.Outlook.T42Meeting,
                                        conversationIds: Glue42Office.Outlook.T42Id[],
                                    }> => {
    return new Promise((resolve, reject) => {
        validateCalendarEventParameters(agm, action, event);
        const id = conversationId ? validateId(conversationId) : null;
        const isTrackItem: boolean = action === "track";
        const conversationIds = combineConversationIds(event, id, isTrackItem);

        const successHandler = () => {
            const response = {event, conversationIds};
            resolve(response);

            if (!isTrackItem) {
                trackItemDictionary.remove(event.ids);
                const untrackIds = event.ids.filter((ids: Glue42Office.Outlook.T42Id) => ids.systemName === ("Outlook.ConversationId"));
                trackItemDictionary.add(event.ids, untrackIds);
            }
        };

        const errorHandler = (err: { message: string }) => {
            reject(err.message);
            return;
        };

        const methodName = isTrackItem ? SyncTrackCalendarItemMethodName : SyncUntrackCalendarItemMethodName;
        const params = {itemIds: event.ids, conversationIds};
        return agm.invoke(methodName, params)
            .then((res) => successHandler())
            .catch((err) => errorHandler(err));
    });
};
